import React, { useContext } from 'react'

import { Backdrop, ButtonV2, CardBody, CardFooter, ListingSkeletonLoader, Sheet, Text } from '@vividseats/vivid-ui-kit'
import { useRouter } from 'next/router'

import filterContext from '@/components/pages/production/components/context'
import dateSwitcherContext from '@/components/pages/production/components/date-switcher/context'
import productionDetailsContext from '@/context/production-details'
import relatedProductionsContext from '@/context/related-productions'
import { trackEvent } from '@/utils/analytics/ga360'

import RelatedProductionOption from './components/related-production-option'
import styles from './styles.module.scss'

const DateSwitcherSheetContent: React.FC = () => {
    const {
        selectors: { dateSwitcherSheetInfo },
    } = useContext(productionDetailsContext)

    const {
        dispatch: { setSelectedProduction, toggleSheet },
        state: { isSheetOpen, selectedProduction },
    } = useContext(dateSwitcherContext)

    const selectedProductionId = selectedProduction?.id
    const selectedProductionWebPath = selectedProduction?.webPath

    const {
        selectors: { dateSwitcherSheetSelector: relatedProductions },
        state: { fetching },
    } = useContext(relatedProductionsContext)

    const {
        dispatch: { onResetSectionSelectionAction: resetSectionSelection },
    } = useContext(filterContext)

    const router = useRouter()

    const handleSelectProduction = (id: number, webPath: string) => {
        setSelectedProduction({ id, webPath })
    }

    return (
        <React.Fragment>
            <Backdrop
                zIndex="sheet"
                isOpen={isSheetOpen}
                onClick={() => {
                    toggleSheet(false)
                }}
            />
            <Sheet responsive className={styles.sheet} toggle={isSheetOpen}>
                <CardBody className={styles.cardBody}>
                    <Text as="h2">{dateSwitcherSheetInfo?.title}</Text>
                    <Text className={styles.subtitle}>{dateSwitcherSheetInfo?.subtitle}</Text>
                    <ListingSkeletonLoader rowCount={dateSwitcherSheetInfo?.productionsCount} isLoading={!!fetching}>
                        {relatedProductions.map(({ date, id, minPrice, ticketCount, webPath }) => (
                            <RelatedProductionOption
                                key={id}
                                checked={id === selectedProductionId}
                                date={date}
                                minPrice={minPrice}
                                onClick={() => handleSelectProduction(id, webPath)}
                                ticketCount={ticketCount}
                            />
                        ))}
                    </ListingSkeletonLoader>
                </CardBody>
                <CardFooter className={styles.cardFooter}>
                    <ButtonV2
                        className={styles.button}
                        data-testid="cancel-button"
                        importance="tertiary"
                        onClick={() => {
                            toggleSheet(false)
                            trackEvent('Date Picker', 'CancelDatePicker', 'clicked', undefined, false)
                        }}
                    >
                        Cancel
                    </ButtonV2>
                    <ButtonV2
                        className={styles.button}
                        data-testid="choose-date-button"
                        onClick={() => {
                            trackEvent(
                                'Production Selection',
                                'Production Page',
                                'Date Picker',
                                selectedProductionId,
                                false,
                            )
                            router.push(selectedProductionWebPath || `/404?productionId=${selectedProductionId}`)
                            resetSectionSelection()
                            toggleSheet(false)
                        }}
                    >
                        Choose Date
                    </ButtonV2>
                </CardFooter>
            </Sheet>
        </React.Fragment>
    )
}

export default DateSwitcherSheetContent
